<div class="espa" :class="[{ 'top-right': topRight }, { 'bottom-left': bottomLeft }]">
    <a href="espa-competitiveness-toolbox-en.pdf" download><img alt="ΕΣΠΑ"
            src="../../assets/media/images/supply-chain/e-bannerespa_1.png"></a>
    <a href="VIMA_WEB3bENb.pdf" download><img alt="ΕΣΠΑ"
            src="../../assets/media/images/supply-chain/e-bannerespa_2.png"></a>
</div>